// React Required
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.scss";
import store from "./store";
import Loader from "./Loader";
import Loadable from "react-loadable";
import history from "./history";
import { seekerRoutes, giverRoutes } from "./constants/routeObject";
import Navbar from "./components/header/Navbar";
import { DATA, GIVERDATA } from "./components/MyPlace/data";
import Feedback from "./components/MyPlace/Seeker/MyDashboard/Feedback";

const UnStoppable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "UnStoppable" */ "./components/Home/Unstoppable"
    ),
  loading: Loader,
});

const PressRelease = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Press Release" */ "./components/Home/PressRelease"
    ),
  loading: Loader,
});

const IWD = Loadable({
  loader: () => import(/* webpackChunkName: "IWD" */ "./Pages/IWD"),
  loading: Loader,
});

const SelfAwareness = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SelfAwareness" */ "./components/MyPlace/Seeker/SelfAwareness/SelfAwareness"
    ),
  loading: Loader,
});

const Coaching = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Coaching" */ "./components/MyPlace/Seeker/Coaching/Coaching"
    ),
  loading: Loader,
});

const ComingSoon = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ComingSoon" */ "./components/MyPlace/Seeker/HappinessPillars/ComingSoon"
    ),
  loading: Loader,
});

const Progress = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Progress" */ "./components/MyPlace/Seeker/MyDashboard/Progress"
    ),
  loading: Loader,
});

const Inspiration = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Inspiration" */ "./components/MyPlace/Seeker/ISeek/Inspiration"
    ),
  loading: Loader,
});

const MyIKIGAI = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "MyIKIGAI" */ "./components/MyPlace/Seeker/HappinessPillars/MyIKIGAI"
    ),
  loading: Loader,
});

const JoinOurClub = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "JoinOurClub" */ "./components/MyPlace/Seeker/HappinessPillars/JoinOurClub"
    ),
  loading: Loader,
});

const OneOnOne = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "OneOnOne" */ "./components/MyPlace/Seeker/ISeek/OneOnOne"
    ),
  loading: Loader,
});

const Resources = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Resources" */ "./components/MyPlace/Seeker/MyDashboard/Resources"
    ),
  loading: Loader,
});

const Referals = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Referals" */ "./components/MyPlace/Seeker/MyDashboard/Referals"
    ),
  loading: Loader,
});

const Workshop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Workshop" */ "./components/MyPlace/Seeker/ISeek/Workshop"
    ),
  loading: Loader,
});

const MyReports = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "MyReports" */ "./components/MyPlace/Seeker/MyDashboard/MyReports"
    ),
  loading: Loader,
});

const Transaction = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Transaction" */ "./components/MyPlace/Seeker/MyDashboard/Transaction"
    ),
  loading: Loader,
});

const Profile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Profile" */ "./components/MyPlace/Seeker/MyProfile/Profile"
    ),
  loading: Loader,
});

const JoinEcosystem = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "JoinEcosystem" */ "./components/MyPlace/Seeker/JoinEcosystem/JoinEcosystem"
    ),
  loading: Loader,
});

const CoachingDetail = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "CoachingDetail" */ "./components/MyPlace/CoachingDetail"
    ),
  loading: Loader,
});

const WorkshopDetail = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "WorkshopDetail" */ "./components/MyPlace/WorkShopDetail"
    ),
  loading: Loader,
});

const ProfileG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ProfileG" */ "./components/MyPlace/Giver/ProfileG"
    ),
  loading: Loader,
});

const ProgressG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ProgressG" */ "./components/MyPlace/Giver/ProgressG"
    ),
  loading: Loader,
});

const SubmissionG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SubmissionG" */ "./components/MyPlace/Giver/SubmissionG"
    ),
  loading: Loader,
});

const ReferalsG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ReferalsG" */ "./components/MyPlace/Giver/ReferalsG"
    ),
  loading: Loader,
});

const OneOnOneG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "OneOnOneG" */ "./components/MyPlace/Giver/OneOnOneG"
    ),
  loading: Loader,
});

const WorkshopG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "WorkshopG" */ "./components/MyPlace/Giver/WorkshopG"
    ),
  loading: Loader,
});

const InspirationG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "InspirationG" */ "./components/MyPlace/Giver/InspirationG"
    ),
  loading: Loader,
});

const ProtectedRoute = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ProtectedRoute" */ "./ProtectedRoute"),
  loading: Loader,
});

const BlogDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BlogDetails" */ "./Pages/BlogDetails"),
  loading: Loader,
});

const AboutUs = Loadable({
  loader: () => import(/* webpackChunkName: "AboutUs" */ "./Pages/AboutUs"),
  loading: Loader,
});

const ServicesPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ServicesPage" */ "./Pages/ServicesPage"),
  loading: Loader,
});

const MyPlace = Loadable({
  loader: () => import(/* webpackChunkName: "MyPlace" */ "./Pages/MyPlace"),
  loading: Loader,
});

// branch = shubham
const Personalisation = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Personalisation" */ "./Pages/Personalisation"),
  loading: Loader,
});


const ResetPassword = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ResetPassword" */ "./components/ResetPassword"
    ),
  loading: Loader,
});
const ForgotPassword = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ForgotPassword" */ "./components/ForgotPassword"
    ),
  loading: Loader,
});
const Login = Loadable({
  loader: () => import(/* webpackChunkName: "Login" */ "./Pages/Login"),
  loading: Loader,
});

const ContactUs = Loadable({
  loader: () => import(/* webpackChunkName: "ContactUs" */ "./Pages/ContactUs"),
  loading: Loader,
});

const EventsPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "EventsPage" */ "./Pages/EventsPage"),
  loading: Loader,
});

const EventDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: "EventDetails" */ "./Pages/EventDetails"),
  loading: Loader,
});

const NotFound = Loadable({
  loader: () => import(/* webpackChunkName: "NotFound" */ "./Pages/NotFound"),
  loading: Loader,
});

const Sitemap = Loadable({
  loader: () => import(/* webpackChunkName: "Sitemap" */ "./Pages/Sitemap"),
  loading: Loader,
});

const LandingPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "LandingPage" */ "./Pages/LandingPage"),
  loading: Loader,
});

const HomePage = Loadable({
  loader: () => import(/* webpackChunkName: "HomePage" */ "./Pages/HomePage"),
  loading: Loader,
});

const HomePage_2 = Loadable({
  loader: () => import(/* webpackChunkName: "HomePage" */ "./Pages/HomePage_2"),
  loading: Loader,
});

const Onboarding = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Onboarding" */ "./Pages/Onboarding"),
  loading: Loader,
});

const BlogsPage = Loadable({
  loader: () => import(/* webpackChunkName: "BlogsPage" */ "./Pages/BlogsPage"),
  loading: Loader,
});

const SelfLearning = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SelfLearning" */ "./components/MyPlace/Seeker/ISeek/SelfLearning"
    ),
  loading: Loader,
});

const Leadership = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Leadership" */ "./components/MyPlace/Seeker/Leadership"
    ),
  loading: Loader,
});

const MasterPage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Stress Management" */ "./components/MyPlace/Seeker/StressMgmt/index"
    ),
  loading: Loader,
});

const EmotionalEating = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Emotional Eating" */ "./components/MyPlace/Seeker/EE/Index"
    ),
  loading: Loader,
});

const Networking = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Networking" */ "./components/MyPlace/Seeker/Networking/Index"
    ),
  loading: Loader,
});

const BodyShame = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Body Shame" */ "./components/MyPlace/Seeker/BodyShame/index"
    ),
  loading: Loader,
});

const NurtureRelationship = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Nurture Relationship" */ "./components/MyPlace/Seeker/NurtureRelationships/index"
    ),
  loading: Loader,
});

const Burnouts = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Burnout" */ "./components/MyPlace/Seeker/Burnout/index"
    ),
  loading: Loader,
});

const Faliure = Loadable({
  loader: () =>
    import(
      "./components/MyPlace/Seeker/Faliure/index"
    ),
  loading: Loader,
});

const Ikigai = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Ikigai" */ "./components/MyPlace/Seeker/Ikigai/Index"
    ),
  loading: Loader,
});

const HeartBreak = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Burnout" */ "./components/MyPlace/Seeker/Heartbreak/index"
    ),
  loading: Loader,
});
const Journey = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Journey" */ "./components/Personalisation/Journey"
    ),
  loading: Loader,
});

const ViewPage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ViewPage" */ "./components/MyPlace/ViewPage"
    ),
  loading: Loader,
});

const NetworkingPage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "NetworkingPage" */ "./Pages/Networking"
    ),
  loading: Loader,
});

const WhatsNew = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "WhatsNew" */ "./Pages/whatsNew"
    ),
  loading: Loader,
});

class Root extends Component {

  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
        <div>
          {/* <Header /> */}
          <Navbar />
          <Switch>
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/`}
              component={HomePage_2}
            // component={HomePage}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/unstoppablewoman`}
              component={UnStoppable}
            />

            <Route
              path={`${process.env.PUBLIC_URL}/iwd`}
              component={IWD}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/aboutus`}
              component={AboutUs}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/onboarding`}
              component={Onboarding}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/services`}
              component={ServicesPage}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/forgot`}
              component={ForgotPassword}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/reset`}
              component={ResetPassword}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/blogs`}
              component={BlogsPage}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/blog-details/:blogid`}
              component={BlogDetails}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/contactus`}
              component={ContactUs}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/events`}
              component={EventsPage}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/event-details`}
              component={EventDetails}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/login`}
              component={Login}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/sitemap`}
              component={Sitemap}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/networking`}
              component={NetworkingPage}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/whats-new`}
              component={WhatsNew}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/press-release`}
              component={PressRelease}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/register`}
              component={() => (
                <LandingPage
                  header={false}
                  title="Accelerate your transformation journey now."
                  wantJoin={true}
                  wantLinkedinCallBack={true}
                />
              )}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/payment-success`}
              component={() => (
                <LandingPage
                  header="Thank you for the payment towards the workshop. You will receive the Zoom meeting details shortly."
                  subHeader="Register to explore personalized and holistic solutions to overcome challenge across career, relationships and health."
                  megaHeader="Accelerate your happiness journey Now."
                  wantJoin={false}
                  wantLinkedinCallBack={true}
                />
              )}
            />
            <ProtectedRoute
              path={seekerRoutes.getPersonalisation}
              component={() => <Personalisation />}
            />
            <ProtectedRoute
              path={giverRoutes.getPersonalisation}
              component={() => <Personalisation />}
            />

            <MyPlace>
              <ProtectedRoute
                path={giverRoutes.getReferal}
                component={() => <ReferalsG />}
              />

              <ProtectedRoute
                path={giverRoutes.getProfile}
                component={() => (
                  <ProfileG />
                )}
              />

              {/* <ProtectedRoute
                                    path={giverRoutes.getProgress}
                  component={() => (
                    <ProgressG />
                  )}
                /> */}

              <ProtectedRoute
                path={giverRoutes.getSubmission}
                component={() => (
                  <SubmissionG />
                )}
              />

              {/* <ProtectedRoute
                                    path={giverRoutes.getTransaction}
                  component={() => (
                    <TransactionG />
                  )}
                /> */}

              <ProtectedRoute
                path={giverRoutes.getOneToOne}
                component={() => (
                  <OneOnOneG />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.getWorkShop}
                component={() => (
                  <WorkshopG />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.getInspiration}
                component={() => (
                  <InspirationG />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.becomeaGiver}
                component={() => (
                  <ViewPage data={GIVERDATA[0]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.viewMyPage}
                component={() => (
                  <ViewPage data={GIVERDATA[1]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.editMyPage}
                component={() => (
                  <ViewPage data={GIVERDATA[2]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.modifyServices}
                component={() => (
                  <ViewPage data={GIVERDATA[3]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.msFree}
                component={() => (
                  <ViewPage data={GIVERDATA[4]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.msPaid}
                component={() => (
                  <ViewPage data={GIVERDATA[5]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.oneOnOne}
                component={() => (
                  <ViewPage data={GIVERDATA[6]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.community}
                component={() => (
                  <ViewPage data={GIVERDATA[7]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.getTransaction}
                component={() => (
                  <ViewPage data={GIVERDATA[8]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.getFrenzcoinG}
                component={() => (
                  <ViewPage data={DATA[9]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.becomeAnEvangelist}
                component={() => (
                  <ViewPage data={DATA[7]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.sessionFeedback}
                component={() => (
                  <ViewPage data={GIVERDATA[9]} />
                )}
              />

              <ProtectedRoute
                path={giverRoutes.journeySoFar}
                component={() => (
                  <ViewPage data={GIVERDATA[10]} />
                )}
              />


              {/* My Place Giver Pages */}

              <ProtectedRoute
                path={seekerRoutes.getMyHappinessIndex}
                component={() => (
                  <SelfAwareness />
                )}
              />


              <ProtectedRoute
                path={seekerRoutes.getSeekerFeedback}
                component={() => (
                  <Feedback />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getCoaching}
                component={() => (
                  <Coaching />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getMyIkigai}
                component={() => (
                  <MyIKIGAI />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getJoinOurClub}
                component={() => (
                  <JoinOurClub />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getComingSoon}
                component={() => (
                  <ComingSoon />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getOneToOne}
                component={() => (
                  <OneOnOne />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getWorkShop}
                component={() => (
                  <Workshop />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getInspiration}
                component={() => (
                  <Inspiration />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getProgress}
                component={() => (
                  <Progress />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getMyReports}
                component={() => (
                  <MyReports />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getTransaction}
                component={() => (
                  <Transaction />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getResource}
                component={() => (
                  <Resources />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getReferal}
                component={() => (
                  <Referals />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getProfile}
                component={() => (
                  <Profile />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getEcoSystem}
                component={() => (
                  <JoinEcosystem />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getCoachingDetail}
                component={() => (
                  <CoachingDetail />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getWorkshopDetail}
                component={() => (
                  <WorkshopDetail />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getModuleRoute}
                component={() => (
                  <SelfLearning />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getStressMgmt}
                component={() => (
                  <MasterPage />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getEmotionalEating}
                component={() => (
                  <EmotionalEating />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getNetworking}
                component={() => (
                  <Networking />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getHeartbreak}
                component={() => (
                  <HeartBreak />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getFaliure}
                component={() => (
                  <Faliure />
                )}
              />
              <ProtectedRoute
                path={seekerRoutes.getBodyShame}
                component={() => (
                  <BodyShame />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getBurnout}
                component={() => (
                  <Burnouts />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getIkigai}
                component={() => (
                  <Ikigai />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getLeadershipModule}
                component={() => (
                  <Leadership />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getNurtureRelationship}
                component={() => (
                  <NurtureRelationship />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getPersonalize}
                component={() =>
                  <ViewPage data={DATA[0]} />
                }
              />

              <ProtectedRoute
                path={seekerRoutes.getFeedback}
                component={() =>
                  <ViewPage data={DATA[8]} />
                }
              />

              <ProtectedRoute
                path={seekerRoutes.journeySoFar}
                component={() =>
                  <ViewPage data={DATA[10]} />
                }
              />

              {/* <ProtectedRoute
                                    path={seekerRoutes.getLearningModule}
                  component={() => (
                    <ViewPage data={DATA[1]} />
                  )}
                /> */}

              <ProtectedRoute
                path={seekerRoutes.getAssessments}
                component={() => (
                  <ViewPage data={DATA[2]} />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.findAnExpert}
                component={() => (
                  <ViewPage data={DATA[4]} />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.becomeaGiver}
                component={() => (
                  <ViewPage data={DATA[5]} />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getCommunity}
                component={() => (
                  <ViewPage data={DATA[6]} />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.becomeAnEvangelist}
                component={() => (
                  <ViewPage data={DATA[7]} />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getHanieRoom}
                component={() => (
                  <ViewPage data={DATA[3]} />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getFrenzcoinS}
                component={() => (
                  <ViewPage data={DATA[9]} />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.findAJob}
                component={() => (
                  <ViewPage data={DATA[11]} />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.shareAJob}
                component={() => (
                  <ViewPage data={DATA[12]} />
                )}
              />

              <ProtectedRoute
                path={seekerRoutes.getJourney}
                component={() => (
                  <Journey />
                )}
              />
            </MyPlace>

            <ProtectedRoute
              path={seekerRoutes.getPersonalisation}
              component={() => <Personalisation />}
            />

            {/* branch = shubham */}


            {/* ///// */}

            {/* ///// */}


            <Route path="*" component={NotFound} />
          </Switch>
        </div>
        </Router>
      </Provider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));
